module.exports = __webpack_public_path__ + "static/img/Home06en@2x.84047ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Home06en@2x.png
// module id = XNtk
// module chunks = 1